import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Select2 from 'react-select2-wrapper';
import headerImage from '../../../assets/img/header/header1-min.jpg';
import types from '../../../data/types.json';

const Banner = () => {
  const [state, setState] = useState({
    locationTypeId: 0,
    assetTypeId: 0,
    priceRange: 0,
  });

  const getSearchParams = () => {
    return `?locationTypeId=${state.locationTypeId}&assetTypeId=${state.assetTypeId}&priceRange=${state.priceRange}`;
  };

  return (
    <div
      className='banner banner-1 bg-cover bg-center'
      style={{
        backgroundImage: 'url(' + headerImage + ' )',
      }}
    >
      <div className='container'>
        <div className='banner-item'>
          <div className='banner-inner'>
            <div className='banner-text'>
              <h1 className='title'>Real Estate Agents Near You</h1>
              <p className='subtitle'>
                Thousands of people have their flats up for grabs. Don't miss
                your chance to grab your own house today.
              </p>
            </div>
            <div className='acr-filter-form'>
              <form onSubmit={(event) => event.preventDefault()}>
                <div className='row'>
                  <div className='col-lg-3 col-md-6'>
                    <div className='form-group acr-custom-select'>
                      <label>Location: </label>
                      <Select2
                        data={types.locationTypes}
                        defaultValue={0}
                        onChange={(event) =>
                          setState({
                            ...state,
                            locationTypeId: event.target.value,
                          })
                        }
                        value={state.locationTypeId}
                      />
                    </div>
                  </div>
                  <div className='col-lg-3 col-md-6'>
                    <div className='form-group acr-custom-select'>
                      <label>Status: </label>
                      <Select2
                        data={types.assetTypes}
                        defaultValue={0}
                        onChange={(event) =>
                          setState({
                            ...state,
                            assetTypeId: event.target.value,
                          })
                        }
                        value={state.assetTypeId}
                      />
                    </div>
                  </div>
                  <div className='col-lg-4 col-md-6'>
                    <div className='form-group acr-custom-select'>
                      <label>Price Range: </label>
                      <Select2
                        data={types.pricerangelist}
                        defaultValue={0}
                        onChange={(event) =>
                          setState({ ...state, priceRange: event.target.value })
                        }
                        value={state.priceRange}
                      />
                    </div>
                  </div>
                  <div className='col-lg-2 col-md-6'>
                    <div className='form-group'>
                      <Link
                        to={'/listings' + getSearchParams()}
                        className='btn-custom primary'
                      >
                        Search listings{' '}
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
